import { useMemo } from 'react';

import getTextWidthFromCanvas from './getTextWidthFromCanvas';
import { UseTypoSizeProps, WidthWithSize } from './useTypoSize.type';

const useTypoSize = ({
  ref,
  text = '',
  max = '5xl',
}: UseTypoSizeProps): any => {
  const w_5xl = useMemo(
    () => getTextWidthFromCanvas(text, `normal 48px sans-serif`),
    [text],
  );
  const w_4xl = useMemo(
    () => getTextWidthFromCanvas(text, `normal 36px sans-serif`),
    [text],
  );
  const w_3xl = useMemo(
    () => getTextWidthFromCanvas(text, `normal 30px sans-serif`),
    [text],
  );
  const w_2xl = useMemo(
    () => getTextWidthFromCanvas(text, `normal 24px sans-serif`),
    [text],
  );
  const w_xl = useMemo(
    () => getTextWidthFromCanvas(text, `normal 20px sans-serif`),
    [text],
  );
  const w_lg = useMemo(
    () => getTextWidthFromCanvas(text, `normal 18px sans-serif`),
    [text],
  );
  const w_base = useMemo(
    () => getTextWidthFromCanvas(text, `normal 16px sans-serif`),
    [text],
  );
  const w_sm = useMemo(
    () => getTextWidthFromCanvas(text, `normal 14px sans-serif`),
    [text],
  );
  const w_xs = useMemo(
    () => getTextWidthFromCanvas(text, `normal 12px sans-serif`),
    [text],
  );

  const widthWithSize = useMemo(() => {
    const sizes = {
      '5xl': w_5xl,
      '4xl': w_4xl,
      '3xl': w_3xl,
      '2xl': w_2xl,
      xl: w_xl,
      lg: w_lg,
      base: w_base,
      sm: w_sm,
      xs: w_xs,
    };

    const maxSize = sizes[max];

    return (
      [
        { width: w_5xl, size: 'headline-extra-large' },
        { width: w_4xl, size: 'headline-large' },
        { width: w_3xl, size: 'headline-medium-large' },
        { width: w_2xl, size: 'headline-medium' },
        { width: w_xl, size: 'body-large' },
        { width: w_lg, size: 'body-large' },
      ] as WidthWithSize[]
    ).filter((w) => w.width <= maxSize);
  }, [max, w_2xl, w_3xl, w_4xl, w_5xl, w_base, w_lg, w_sm, w_xl, w_xs]);

  return (
    widthWithSize.find((f) => f.width < (ref?.clientWidth || 0))?.size || 'base'
  );
};

export default useTypoSize;
